<template>
    <div class="main-content">
        <header class="content-header mb-3 mt-n5">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0 align-items-center flex-nowrap">
            <li class="breadcrumb-item text-nowrap">
                <router-link class="nav-link active d-inline p-0" to="/">Início</router-link>
            </li>
            <li class="breadcrumb-item text-nowrap">
                <router-link class="nav-link active d-inline p-0" to="/list-landing-page">Gestão de Campanhas</router-link>
            </li>
            <li class="breadcrumb-item active text-dark small text-nowrap">
                Doações da Campanha
            </li>
        </ol>
    </nav>
</header>

        <div class="card p-4 shadow-subtle rounded-4 border-0 mb-4">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h5 class="mb-0 fw-bold">Doações Recebidas</h5>
                    <span class="text-muted small">Exibindo {{ donations.length }} de {{ totalItems }} registros</span>
                </div>
                <div class="d-flex gap-2 align-items-center">
                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter, 'border-primary text-primary fw-bold': hasActiveFilters }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>
                    <button class="btn btn-pmg-light" @click="fetchDonations(1, false)" :disabled="loading" title="Atualizar">
                        <i class="bi bi-arrow-clockwise" :class="{ 'spin-animation': loading }"></i>
                    </button>
                </div>
            </div>

            <!-- FILTROS -->
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3 align-items-end">
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Nome do Apoiador</label>
                            <input v-model="filter.name_client" type="text" class="form-control form-control-pmg" placeholder="Ex: João Silva">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Status</label>
                            <select v-model="filter.status" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option value="paid">Aprovado (Pago)</option>
                                <option value="pending">Pendente</option>
                                <option value="failed">Falhou</option>
                                <option value="refunded">Reembolsado</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label text-muted small fw-bold mb-1">Data Inicial</label>
                            <input v-model="filter.date_from" type="date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label text-muted small fw-bold mb-1">Data Final</label>
                            <input v-model="filter.date_to" type="date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-12 d-flex justify-content-start gap-2 mt-3">
                            <button class="btn btn-pmg-primary fw-bold py-2 px-4" @click="fetchDonations(1, false)">
                                <i class="bi bi-search me-2"></i> Filtrar
                            </button>
                            <button class="btn btn-outline-danger py-2 px-3" @click="clearFilters">
                                <i class="bi bi-x-lg"></i> Limpar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABELA DE DOAÇÕES -->
<div class="table-responsive table-scroll-container">
    <table class="table table-pmg align-middle mb-0">
        <thead>
            <tr>
                <th style="width: 30%">Apoiador</th>
                <th style="width: 20%" class="text-end">Valor doado</th>
                <th style="width: 20%" class="text-center">Status</th>
                <th style="width: 20%">Data</th>
                <th style="width: 10%" class="text-end">Ações</th>
            </tr>
        </thead>
        <tbody v-if="donations.length > 0">
            <tr v-for="item in donations" :key="item.id">
                <td>
                    <div class="fw-bold text-dark">
                        <i class="bi bi-incognito text-muted me-1" v-if="item.is_anonymous"></i>
                        {{ item.is_anonymous ? 'Apoiador Anônimo' : (item.name_client || 'N/D') }}
                    </div>
                    <span class="text-muted small" v-if="!item.is_anonymous">{{ item.email || 'Sem e-mail' }}</span>
                </td>
                <td class="text-end fw-bold text-success">
                    R$ {{ formatCurrency(item.amount_paid ?? item.amount) }}
                </td>
                <td class="text-center">
                    <span class="badge rounded-pill px-3 py-2" :class="getStatusClass(item.status)">
                        {{ getStatusLabel(item.status) }}
                    </span>
                </td>
                <td>
                    {{ formatDate(item.created_at) }}
                </td>
                <td class="text-end">
                    <button class="btn btn-pmg-light btn-sm" @click="viewDetails(item)">
                        <i class="bi bi-eye"></i>
                    </button>
                </td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="5" class="text-center py-5 text-muted">
                    <i class="bi bi-heart fs-1 mb-2 opacity-50"></i><br>
                    Nenhuma doação encontrada para esta campanha.
                </td>
            </tr>
        </tbody>
    </table>
</div>

            <!-- BOTÃO CARREGAR MAIS -->
            <div class="text-center mt-4" v-if="hasMore">
                <button class="btn btn-pmg-light px-5 btn-sm fw-bold" @click="loadMore" :disabled="loading">
                    Carregar mais
                </button>
            </div>
        </div>
    </div>
<!-- MODAL DE DETALHES DA DOAÇÃO -->
        <div v-if="selectedDonation" class="modal fade show d-block custom-modal-backdrop" tabindex="-1" @click.self="closeDetails">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    
                    <!-- Cabeçalho -->
                    <div class="modal-header border-0 pt-4 px-4 pb-3 bg-light rounded-top-4">
                        <h5 class="modal-title fw-bold text-dark d-flex align-items-center gap-2">
                            <i class="bi bi-receipt" style="color: #561569;"></i> 
                            Detalhes da Transação
                        </h5>
                        <button type="button" class="btn-close" @click="closeDetails" aria-label="Fechar"></button>
                    </div>
                    
                    <!-- Corpo do Modal -->
                    <div class="modal-body p-4">
                        <div class="row g-4">
                            <!-- Bloco 1: Apoiador -->
                            <div class="col-md-6">
                                <h6 class="fw-bold text-muted small text-uppercase mb-2">Dados do Apoiador</h6>
                                <div class="p-3 bg-light rounded-3 border">
                                    <div class="fw-bold text-dark mb-1">
                                        <i class="bi bi-incognito text-muted me-1" v-if="selectedDonation.is_anonymous"></i>
                                        {{ selectedDonation.is_anonymous ? 'Apoiador Anônimo' : (selectedDonation.name_client || 'N/D') }}
                                    </div>
                                    <div class="text-secondary small mb-1"><i class="bi bi-envelope me-1"></i> {{ selectedDonation.email || 'Não informado' }}</div>
                                    <div class="text-secondary small"><i class="bi bi-person-vcard me-1"></i> CPF/CNPJ: {{ selectedDonation.document || 'Não informado' }}</div>
                                </div>
                            </div>

                            <!-- Bloco 2: Valores e Status -->
                            <div class="col-md-6">
                                <h6 class="fw-bold text-muted small text-uppercase mb-2">Resumo Financeiro</h6>
                                <div class="p-3 bg-light rounded-3 border">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <span class="text-secondary small">Valor Pago:</span>
                                        <span class="fw-bold text-success fs-5">R$ {{ formatCurrency(selectedDonation.amount_paid ?? selectedDonation.amount) }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <span class="text-secondary small">Status:</span>
                                        <span class="badge rounded-pill px-2 py-1" :class="getStatusClass(selectedDonation.status)">
                                            {{ getStatusLabel(selectedDonation.status) }}
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="text-secondary small">Data:</span>
                                        <span class="text-dark fw-medium small">{{ formatDate(selectedDonation.created_at) }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Bloco 3: Mensagem de Apoio -->
                            <div class="col-12" v-if="selectedDonation.comment">
                                <h6 class="fw-bold text-muted small text-uppercase mb-2">Mensagem de Apoio</h6>
                                <div class="p-3 bg-warning-subtle text-dark rounded-3 border border-warning-subtle fst-italic">
                                    "{{ selectedDonation.comment }}"
                                </div>
                            </div>

                            <!-- Bloco 4: Dados Técnicos (Para o Admin) -->
                            <div class="col-12">
                                <h6 class="fw-bold text-muted small text-uppercase mb-2">Dados Técnicos</h6>
                                <ul class="list-group list-group-flush border rounded-3 text-secondary small">
                                    <li class="list-group-item bg-light d-flex justify-content-between px-3 py-2">
                                        <span>Método de Pagamento:</span>
                                        <span class="text-dark fw-medium text-uppercase">{{ selectedDonation.payment_method || 'PIX' }}</span>
                                    </li>
                                    <li class="list-group-item bg-light d-flex justify-content-between px-3 py-2">
                                        <span>ID da Transação:</span>
                                        <span class="text-dark fw-medium">{{ selectedDonation.transaction_id || selectedDonation.id }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Rodapé -->
                    <div class="modal-footer border-0 p-3 bg-light rounded-bottom-4 d-flex justify-content-end">
                        <button type="button" class="btn btn-pmg-light px-4 fw-medium" @click="closeDetails">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import api from '@/services/api';

export default {
    name: 'CampaignDonations',
    data() {
        return {
            campaignId: null,
            donations: [],
            filter: { name_client: '', status: '', date_from: '', date_to: '' },
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            perPage: 15,
            loading: false,
            hasMore: false,
            showFilter: false,
            selectedDonation: null,
        }
    },
    computed: {
        hasActiveFilters() {
            return Object.values(this.filter).some(val => val !== '');
        }
    },
    created() {
        // Pega o ID da rota (ex: /admin/landing-pages/123-uuid-456/donations)
        this.campaignId = this.$route.params.id; 
        this.fetchDonations();
    },
    methods: {
        async fetchDonations(page = 1, append = false) {
            this.loading = true;
            try {
                const response = await api.get(`/admin-landing-page/${this.campaignId}/donations`, {
                    params: { page, per_page: this.perPage, ...this.filter }
                });

                const pagedData = response.data;
                const items = pagedData.data || [];

                this.donations = append ? [...this.donations, ...items] : items;
                this.totalItems = pagedData.total || 0;
                this.currentPage = pagedData.current_page || 1;
                this.lastPage = pagedData.last_page || 1;
                this.hasMore = this.currentPage < this.lastPage;
            } catch (error) {
                console.error("Erro ao buscar doações:", error);
                // Adicione sua notificação de erro global aqui
            } finally {
                this.loading = false;
            }
        },
        clearFilters() {
            this.filter = { name_client: '', status: '', date_from: '', date_to: '' };
            this.fetchDonations(1, false);
        },
        loadMore() {
            if (this.hasMore) {
                this.fetchDonations(this.currentPage + 1, true);
            }
        },
        formatCurrency(value) {
            return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            return new Date(dateString).toLocaleDateString('pt-BR', {
                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
            });
        },
        getStatusLabel(status) {
            const labels = {
                'paid': 'Aprovado',
                'pending': 'Pendente',
                'failed': 'Falhou',
                'refunded': 'Reembolsado',
                'chargeback': 'Chargeback'
            };
            return labels[status] || status;
        },
        getStatusClass(status) {
            const classes = {
                'paid': 'bg-success-subtle text-success border border-success-subtle',
                'pending': 'bg-warning-subtle text-warning',
                'failed': 'bg-danger-subtle text-danger',
                'refunded': 'bg-secondary text-white',
                'chargeback': 'bg-danger text-white'
            };
            return classes[status] || 'bg-light text-dark';
        },
      
        viewDetails(item) {
        this.selectedDonation = item;
        document.body.style.overflow = 'hidden'; 
    },
    
    closeDetails() {
        this.selectedDonation = null;
        document.body.style.overflow = 'auto'; 
    }
    }
}
</script>

<style scoped>
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}
.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}
.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 50px;
    padding: 8px 20px;
    font-weight: 500;
}
.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}
.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}
.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}
.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}
.custom-modal-backdrop {
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(2px);
    z-index: 1050;
    overflow-y: auto; 
}
.table-scroll-container {
    max-height: 520px; 
    overflow-y: auto;  
    border: 1px solid #edf2f7;
    border-radius: 12px;
}

.table-pmg thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f8fafc; 
    box-shadow: inset 0 -1px 0 #edf2f7; 
}

.table-scroll-container::-webkit-scrollbar {
    width: 6px;
}

.table-scroll-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
</style>